/**
 * Scroll Triggered Animations
 * Uses IntersectionObserver to trigger fade-in animations when elements scroll into view
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Check if IntersectionObserver is supported
    if (!('IntersectionObserver' in window)) {
      // Fallback: show all elements immediately
      var elements = document.querySelectorAll('.animate-on-scroll');
      for (var i = 0; i < elements.length; i++) {
        elements[i].classList.add('animated');
      }
      return;
    }

    // Create observer with options
    var observerOptions = {
      root: null, // viewport
      rootMargin: '0px',
      threshold: 0.15 // trigger when 15% of element is visible
    };

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Add animated class when element enters viewport
          entry.target.classList.add('animated');
          // Stop observing this element (animation triggers only once)
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe all elements with animate-on-scroll class
    var animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach(function(element) {
      observer.observe(element);
    });
  }
})();
